<template>
  <div>جاري المعالجة...</div>
</template>

<script>
import { resetAccessToken } from '@/helpers/utils';
import oidcConfig from '@/helpers/oidc.config';

export default {
  name: 'AuthLogout',
  mounted() {
    resetAccessToken();
    window.location.href = `${oidcConfig.authority}/Account/Logout`;

  },
};
</script>
